import type { FaireProductEntity } from "../../entity_types/product";

export const p_fjxkcwfyuq: FaireProductEntity = {
  token: "p_fjxkcwfyuq",
  type: "product",
  name: "C.C Baby Solid Ribbed Pom Beanie and Mitten Glove",
  brandToken: "b_926lzrw9gt",
  brandName: "Hana",
  imageUrl:
    "https://cdn.faire.com/fastly/33a9fa76a11ad0427f3960ea46297acafc076360ae3ddfa0d36d3a1f44bfa8a0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0dcc8c302a09f674756f49351a7d841598fdddfa67b49f0fb7b8451ec79ba0f5.jpeg",
    "https://cdn.faire.com/fastly/0ef6f65b1be87a420404eb9a73a5110fcc7b4ef01d1c8ef77c088a27d200f617.jpeg",
    "https://cdn.faire.com/fastly/ee4fe39b3220260e77252ccc99332c2534e782a7e3c81420fd70c4f9b7457d34.jpeg",
    "https://cdn.faire.com/fastly/d360e5f4a8cd497017df930743211f54b17a7a25060c8218cbc1164875cb0d45.jpeg",
    "https://cdn.faire.com/fastly/9bb1faf91ba1a3ec566ed3e53bb4aa1e34e7222985aeba084c3c988c9a3e580a.jpeg",
    "https://cdn.faire.com/fastly/771ae5a19f465a6c37920d031b39348746e7fed6bf2e93f96847eac8a0dcec66.jpeg",
    "https://cdn.faire.com/fastly/6d97e436e93bd674d380544a15b414c44e1e6f38df3d51240f6b4172026cc3d2.jpeg",
    "https://cdn.faire.com/fastly/428a8725a6f3261b36b47c3fa3acdc5953cf28bcedb76185367f8445bf725f57.jpeg",
    "https://cdn.faire.com/fastly/252774054420f798c1ac56758228f3a76caeca2f8dbd6ba54774289a6f2b1b68.jpeg",
    "https://cdn.faire.com/fastly/0240c44677d6e4e860bd6f009483326b361fedefe7529eaefd08d33c1dc947c0.jpeg",
  ],
  priceDollars: 19.75,
  description:
    "C.C Baby Solid Ribbed Pom Beanie and Mitten Glove\n0-9 Month\n100% Acrylic",
  tags: [],
  msrpDollars: 39.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:07.802Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
